import React from 'react';
import { withRouter } from 'react-router';

import CreateCompilationButton from '@vp-ui/components/ToPublishingPageButton/CreateCompilationButton';
import APP_ROUTES from '@src/app_routes';

export const ToPublishingPageButton = withRouter(
  ({ history, location, campaignId = '', ...rest }) => {
    const handleClick = () => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set('create', 'true');
      campaignId && searchParams.set('campaignId', campaignId);

      history.push({
        pathname: APP_ROUTES.videoLibraries,
        search: searchParams.toString()
      });
    };

    return <CreateCompilationButton onClick={handleClick} {...rest} />;
  }
);

export default ToPublishingPageButton;



// WEBPACK FOOTER //
// ./src/vp-ui/components/ToPublishingPageButton/ToPublishingPageButton.jsx